// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/lead_day_count_method.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/lead_day_count_method.proto.
 */
export const file_bfftypes_v1_lead_day_count_method: GenFile = /*@__PURE__*/
  fileDesc("CidiZmZ0eXBlcy92MS9sZWFkX2RheV9jb3VudF9tZXRob2QucHJvdG8SC2JmZnR5cGVzLnYxKo0BChJMZWFkRGF5Q291bnRNZXRob2QSJQohTEVBRF9EQVlfQ09VTlRfTUVUSE9EX1VOU1BFQ0lGSUVEEAASJwojTEVBRF9EQVlfQ09VTlRfTUVUSE9EX0NBTEVOREFSX0RBWVMQARInCiNMRUFEX0RBWV9DT1VOVF9NRVRIT0RfQlVTSU5FU1NfREFZUxACQkJaQGdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnR5cGVzL3YxO2JmZnR5cGVzdjFiBnByb3RvMw");

/**
 * LeadDayCountMethod はオプション通告のリードタイム日数の換算方式。
 * Mirrors backend types.v1.LeadDayCountMethod 1:1 (wire values are stable).
 * Hosted under bfftypes/v1 for BFF-local reuse.
 *
 * @generated from enum bfftypes.v1.LeadDayCountMethod
 */
export enum LeadDayCountMethod {
  /**
   * @generated from enum value: LEAD_DAY_COUNT_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * カレンダー日換算: 土日祝も 1 日としてカウントする。
   *
   * @generated from enum value: LEAD_DAY_COUNT_METHOD_CALENDAR_DAYS = 1;
   */
  CALENDAR_DAYS = 1,

  /**
   * 営業日換算: 対象契約のカレンダー判定で平日のみカウントする。
   *
   * @generated from enum value: LEAD_DAY_COUNT_METHOD_BUSINESS_DAYS = 2;
   */
  BUSINESS_DAYS = 2,
}

/**
 * Describes the enum bfftypes.v1.LeadDayCountMethod.
 */
export const LeadDayCountMethodSchema: GenEnum<LeadDayCountMethod> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_lead_day_count_method, 0);

